var toS = require('./toS')

/**
 * @param  {*} x value
 * @return {boolean} isNumber
 *
 * @since 3.0.0
 * @memberOf is
 * @func isNumber
 * @see is/real
 *
 * @example
 *
 *  isNumber(1)
 *  //=> true
 *  isNumber(Number(1))
 *  //=> true
 *  isNumber(NaN)
 *  //=> true
 *
 *  isNumber(null)
 *  //=> false
 *  isNumber(undefined)
 *  //=> false
 *  isNumber(void 0)
 *  //=> false
 *  isNumber({})
 *  //=> false
 *  isNumber('')
 *  //=> false
 *  isNumber(false)
 *  //=> false
 *
 * @NOTE was not needed except for abstract ==
 *   const isObj = require('./obj')
 *   const isSymbol = require('./symbol')
 *   (isObj(x) || isSymbol(x)
 *     ? false
 *     : (/^0x[0-9a-f]+$/i).test(x) ||
 *         (/^[-+]?(?:\d+(?:\.\d*)?|\.\d+)(e[-+]?\d+)?$/).test(x))
 */
module.exports = function (x) { return typeof x === 'number' || toS(x) === '[object Number]'; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibnVtYmVyLmpzIiwic291cmNlcyI6WyJudW1iZXIuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgdG9TID0gcmVxdWlyZSgnLi90b1MnKVxuXG4vKipcbiAqIEBwYXJhbSAgeyp9IHggdmFsdWVcbiAqIEByZXR1cm4ge2Jvb2xlYW59IGlzTnVtYmVyXG4gKlxuICogQHNpbmNlIDMuMC4wXG4gKiBAbWVtYmVyT2YgaXNcbiAqIEBmdW5jIGlzTnVtYmVyXG4gKiBAc2VlIGlzL3JlYWxcbiAqXG4gKiBAZXhhbXBsZVxuICpcbiAqICBpc051bWJlcigxKVxuICogIC8vPT4gdHJ1ZVxuICogIGlzTnVtYmVyKE51bWJlcigxKSlcbiAqICAvLz0+IHRydWVcbiAqICBpc051bWJlcihOYU4pXG4gKiAgLy89PiB0cnVlXG4gKlxuICogIGlzTnVtYmVyKG51bGwpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzTnVtYmVyKHVuZGVmaW5lZClcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNOdW1iZXIodm9pZCAwKVxuICogIC8vPT4gZmFsc2VcbiAqICBpc051bWJlcih7fSlcbiAqICAvLz0+IGZhbHNlXG4gKiAgaXNOdW1iZXIoJycpXG4gKiAgLy89PiBmYWxzZVxuICogIGlzTnVtYmVyKGZhbHNlKVxuICogIC8vPT4gZmFsc2VcbiAqXG4gKiBATk9URSB3YXMgbm90IG5lZWRlZCBleGNlcHQgZm9yIGFic3RyYWN0ID09XG4gKiAgIGNvbnN0IGlzT2JqID0gcmVxdWlyZSgnLi9vYmonKVxuICogICBjb25zdCBpc1N5bWJvbCA9IHJlcXVpcmUoJy4vc3ltYm9sJylcbiAqICAgKGlzT2JqKHgpIHx8IGlzU3ltYm9sKHgpXG4gKiAgICAgPyBmYWxzZVxuICogICAgIDogKC9eMHhbMC05YS1mXSskL2kpLnRlc3QoeCkgfHxcbiAqICAgICAgICAgKC9eWy0rXT8oPzpcXGQrKD86XFwuXFxkKik/fFxcLlxcZCspKGVbLStdP1xcZCspPyQvKS50ZXN0KHgpKVxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHggPT4gdHlwZW9mIHggPT09ICdudW1iZXInIHx8IHRvUyh4KSA9PT0gJ1tvYmplY3QgTnVtYmVyXSdcbiJdLCJuYW1lcyI6WyJjb25zdCJdLCJtYXBwaW5ncyI6IkFBQUFBLEdBQUssQ0FBQyxHQUFHLEdBQUcsT0FBTyxDQUFDLE9BQU8sQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUF5QzVCLE1BQU0sQ0FBQyxPQUFPLEdBQUcsVUFBQSxDQUFDLENBQUEsQ0FBQyxBQUFHLFNBQUEsT0FBTyxDQUFDLEtBQUssUUFBUSxJQUFJLEdBQUcsQ0FBQyxDQUFDLENBQUMsS0FBSyxpQkFBaUIsR0FBQTsifQ==